export default __webpack_public_path__ + "static/cloud_technologies_tab_image-70496a89301283a3f8fb95d1f933d388.svg";